import React, { useState } from 'react';

import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import ChevronIcon from '../svg-components/ChevronIcon';
import CopyIcon from '../svg-components/CopyIcon';
import CopySuccessIcon from '../svg-components/CopySuccessIcon';
import useMobileDetection from '../../hooks/use-mobile-detection';

import * as styles from './index.module.scss';

const TeamCard = ({
    image,
    name,
    telephoneNumber,
    jobTitle,
    areas,
    areaSlug
}) => {
    const [copied, setCopied] = useState(false);
    const isMobile = useMobileDetection();

    const handleCopy = (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(telephoneNumber);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }

    return (
        <a 
            className={styles.TeamCard}
            href={`/asm-forms?${areaSlug && areaSlug}`}
            title={`Contact ${name}`}
        >
            <div className={styles.TeamCardImage}>
                {(typeof image !== 'undefined') ? <GatsbyImage image={getImage(image)} alt={image?.title} /> : null}
            </div>
            <div className={styles.TeamCardWrap}>
                {name && name.length > 0 ? <p className={styles.name}>{name}</p> : null}
                {areas && areas.length > 0 ? (
                    <p className={styles.region}>
                        <strong>Areas covered:</strong> {areas}
                    </p>
                ) : null}
                {jobTitle && jobTitle.length > 0 ? (
                    <p className={styles.region}>
                        <strong>Role:</strong> {jobTitle}
                    </p>
                ) : null}
                {telephoneNumber && telephoneNumber.length > 0 ? (
                    <div className={styles.telephoneContainer}>
                        <strong>Tel:</strong>
                        {isMobile ? (
                            <a href={`tel:${telephoneNumber}`} className={styles.telLink} title={`Call ${name}`}>
                                {telephoneNumber}
                            </a>
                        ) : (
                            <>
                                {telephoneNumber}
                                <button onClick={(e) => handleCopy(e)} className={styles.copyButton} type="button">
                                    {copied ? (
                                        <>
                                            <CopySuccessIcon className={styles.copyIcon} />
                                            Copied!
                                        </>
                                    ) : (
                                        <>
                                            <CopyIcon className={styles.copyIcon} />
                                        </>
                                    )}
                                </button>
                            </>
                        )}
                    </div>
                ) : null}
                <div className={styles.emailMe}>
                    Email me
                </div>
            </div>
        </a>
    );
};

export default TeamCard;